
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import { CoinHistory } from '@/models/CoinHistory'
import DateUtils from '@/utils/DateUtils'

/**
 * コイン獲得履歴モーダル
 */
@Component({
  components: {
    ModalWindow,
  },
})
export default class ModalCoinHistory extends Vue {
  /** モーダルウィンドウ */
  @Ref()
  modalWindow!: ModalWindow

  /** コイン獲得履歴一覧 */
  @Prop()
  private coinHistoryList!: CoinHistory[]

  /**
   * 日付のフォーマット
   *
   * @param date 日付(Date型)
   * @returns フォーマットされた日付
   */
  private formatDate(date: Date): string {
    return DateUtils.format(date, false)
  }

  /**
   * モーダルを開く
   */
  public show(): void {
    this.modalWindow.show()
  }
}
